<template>
  <DModal :show-close="false" :isBgOverlay="true" @close="$emit('close')">
    <div class="d-modal" slot="insertComponent">
      <div class="d-modal__header">
        <h2>Åbningstider</h2>
      </div>
      <div class="d-modal__content">
        <table class="d-table">
          <thead>
          <tr>
            <th>Dag</th>
            <th>Åbner</th>
            <th>Lukker</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(time, day) in openingHours" :key="day">
            <td>{{ getDayName(day) }}</td>
            <td>
              <input
                type="time"
                v-model="time.open"
                @change="formatTime(day, 'open')"
              />
            </td>
            <td>
              <input
                type="time"
                v-model="time.close"
                @change="formatTime(day, 'close')"
              />
            </td>
            <td>
              <div class="icon__bg-circle icon__bg-circle--danger"
                   v-tippy="{
                    arrow: false,
                    placement : 'right'
                  }"
                   :content="'Slet'" @click="deleteDay(day)">
                <span class="icon-bin"></span>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="do-modal__footer">
        <button class="do-bttn" @click="$emit('close')">{{ $t('vue2.common.cancel') }}</button>
        <button class="do-bttn do-bttn--submit" :class="{'do-bttn--submit--loading': isSaving}" @click="saveOpeningHours">{{
            $t('vue2.common.save')
          }}
        </button>
      </div>
    </div>
  </DModal>
</template>
<script>
import DModal from '../common/DModal.vue'
import moment from 'moment'

export default {
  components: {DModal},
  props: {
    propOpeningHours: {
      default: {
        1: {open: '08:00', close: '22:00'},
        2: {open: '08:00', close: '16:00'},
        3: {open: '08:00', close: '16:00'},
        4: {open: '08:00', close: '16:00'},
        5: {open: '08:00', close: '16:00'},
        6: {open: '', close: ''},
        7: {open: '', close: ''}
      }
    }
  },
  data () {
    return {
      // Default åbningstider
      openingHours: {
        /*
        1: {open: '08:00', close: '16:00'},
        2: {open: '08:00', close: '16:00'},
        3: {open: '08:00', close: '16:00'},
        4: {open: '08:00', close: '16:00'},
        5: {open: '08:00', close: '16:00'},
        6: {open: '', close: ''},
        7: {open: '', close: ''}
         */
      },
      isSaving: false
    }
  },
  watch: {
    propOpeningHours (val, oldVal) {
      this.loadOpeningHours()
      this.$emit('close')
    }
  },
  methods: {
    deleteDay (day) {
      this.openingHours[day]['open'] = ''
      this.openingHours[day]['close'] = ''
    },
    // Konverter dagnummer til dagnavn med Moment.js
    getDayName (day) {
      return moment().isoWeekday(day * 1).format('dddd') // Mandag, Tirsdag osv.
    },
    // Formater tiden med Moment.js
    formatTime (day, type) {
      const time = this.openingHours[day][type]
      if (time) {
        this.openingHours[day][type] = moment(time, 'HH:mm').format('HH:mm')
      }
    },
    // Gem åbningstider som JSON
    saveOpeningHours () {
      this.isSaving = true
      const openingHoursJson = this.openingHours
      this.$store.dispatch('updateSchoolSettings', {'openingHours': openingHoursJson})
    },
    loadOpeningHours () {
      const storedData = this.propOpeningHours
      if (storedData) {
        this.openingHours = storedData
      } else {
        // Hvis ingen data findes, brug standardværdier
        this.openingHours = {
          1: {open: '08:00', close: '22:00'},
          2: {open: '08:00', close: '16:00'},
          3: {open: '08:00', close: '16:00'},
          4: {open: '08:00', close: '16:00'},
          5: {open: '08:00', close: '16:00'},
          6: {open: '', close: ''},
          7: {open: '', close: ''}
        }
      }
    }
  },
  created () {
    this.loadOpeningHours()
  }
}
</script>

<style scoped>
.do-modal__footer {
  gap: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// DutyScheduleOpeningHours.vue?52e826a4